import pwywDiscounts from './pwyw-discounts';

function onKeyChange(event) {
  const value = event.target.value;
  const errorElement = document.querySelector('.pwyw-input-error');
  const pwywInputElement = document.querySelector('#pwyw-amount');
  const pwywParentElement = pwywInputElement.parentElement;
  const maxValue = Number(pwywInputElement.getAttribute('max'));
  // Regex to match a number with no decimal places
  const validNumberRegex = /^\d+$/;
  let hasError = false;

  // Check if value is a valid number and matches the regex
  if (!validNumberRegex.test(value)) {
    hasError = true;
  } else if (Number(value) > maxValue && maxValue > 0) {
    hasError = true;
  }
  // If the input is empty, we don't want to show an error
  if (value === '' && hasError) {
    hasError = false;
  }

  errorElement.hidden = !hasError;

  // if key changes and suggestion button is selected, deselect it
  const optionButtons = document.querySelectorAll('.pwyw-suggestion-button');
  optionButtons.forEach((button) => {
    button.classList.remove('--is-selected');
  });

  // if value is present, add a background to the parent element
  if (value) {
    pwywParentElement.classList.add('--has-value');
  } else {
    pwywParentElement.classList.remove('--has-value');
  }
}

function onAddToCartSuggestedPrice(event) {
  const button = event.target;
  button.classList.add('--is-selected');
  const suggestedPrice = button.getAttribute('data-amount');
  const pwywInputElement = document.querySelector('#pwyw-amount');
  pwywInputElement.value = suggestedPrice;
  // remove other selected states
  const optionButtons = document.querySelectorAll('.pwyw-suggestion-button');
  optionButtons.forEach((btn) => {
    if (btn !== button) {
      btn.classList.remove('--is-selected');
    }
  });
}

// This function will maintain the pdp state when there is any change in cart drawer
function PWYWBracelet() {
  const isPWYWBraceletProductPage = document.querySelector('.bracelet-pwyw-product-page');

  // This function will be handling the pdp state by showing and hiding the submit and unavailable button
  async function init() {
    const currentBraceletContainer = document.querySelector('product-info');
    const submitButton = currentBraceletContainer.querySelector('.product-form__submit');
    const currentBraceletHandle = currentBraceletContainer.getAttribute('data-handle');
    const notAvailableButton = currentBraceletContainer.querySelector('.product-form__unavailable-button-pwyw');
    // current bracelet details.
    const currentBraceletDetail = await productDetails(currentBraceletHandle);

    // This function will be handling the pdp state by showing and hiding the submit and unavailable button
    function handleBraceletPdpState(updatedCart) {
      // reverting the disabled state of submit button
      if (submitButton.children[0].innerText !== 'Out of stock') {
        submitButton.removeAttribute('disabled');
      }

      if (updatedCart && currentBraceletDetail) {
        var isPWYWBraceletInCart = updatedCart.items.filter((item) => {
          const { discounts } = item;
          const hasPWYWDiscount = discounts.some((discount) => {
            const { title } = discount;
            return title.includes('PWYW_');
          });
          return hasPWYWDiscount;
        });

        // If PWYW bracelet is there in cart and the current pdp is of PWYW bracelet
        if (
          isPWYWBraceletInCart &&
          isPWYWBraceletInCart.length === 1 &&
          currentBraceletDetail.tags.includes('pwywbracelet')
        ) {
          submitButton.classList.add('hidden');
          notAvailableButton.classList.remove('hidden');
        } else {
          submitButton.classList.remove('hidden');
          notAvailableButton.classList.add('hidden');
        }

        // Update edit button and input field state
        if (isPWYWBraceletInCart) {
          const pwywInputElement = document.querySelector('#pwyw-amount');
          const pwywInputValue = pwywInputElement.value;

          if (pwywInputValue) {
            const errorElement = document.querySelector('.pwyw-input-error');
            errorElement.hidden = true;
          }
        }
      }
    }

    // Product defail api
    function productDetails(handle) {
      return window
        .fetch(`/products/${handle}.js`, {
          credentials: 'same-origin',
          method: 'GET',
        })
        .then((response) => {
          return response.json();
        });
    }

    function getUpdatedCart() {
      // Making submit button disabled for initial load
      submitButton.setAttribute('disabled', true);

      return window
        .fetch(`/cart.js`)
        .then((response) => response.json())
        .then((data) => {
          handleBraceletPdpState(data);
        });
    }

    getUpdatedCart();
  }

  if (isPWYWBraceletProductPage) {
    init();
  }
}

window.updatePWYWBraceletState = PWYWBracelet;
window.pwywDiscounts = pwywDiscounts;

if (document.body.classList.contains('template-product-bracelets-pwyw')) {
  PWYWBracelet();

  const pwywInputElement = document.querySelector('#pwyw-amount');
  const optionButtons = document.querySelectorAll('.pwyw-suggestion-button');
  optionButtons.forEach((button) => {
    button.addEventListener('click', onAddToCartSuggestedPrice);
  });

  if (pwywInputElement) {
    pwywInputElement.addEventListener('input', onKeyChange);
  }
}
